<template>
  <div>
    <div id="head">{{ title }}</div>
    <div id="body">
      <div id="heading">
        <div class="filter">
          <el-form inline>
            <el-form-item label="選擇分類類別">
              <el-radio-group v-model="type" @change="categoryChange">
                <el-radio-button :label="1">分公司</el-radio-button>
                <el-radio-button :label="2">部門/物業</el-radio-button>
                <el-radio-button :label="3">組別</el-radio-button>
                <el-radio-button :label="4">職位</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="false">
              <el-button class="export" type="primary" @click="exportClicked" :loading="exportLoading">導 出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="graph-title">{{graphTitle}}</div>
        <div class="graph-sub-title" v-if="subTitle">{{subTitle}}</div>
      </div>
      <div id="echart2" class="statistics">
        <div id="analyze"></div>
        <div class="statistics">
          <el-button
            type="success"
            icon="el-icon-download"
            @click="restoreImg(0)"
          ></el-button>
          <p></p>
          <table cellpadding="10px">
            <tr>
              <td>合格：{{ read }}人</td>
              <td>不合格：{{ unread }}人</td>
              <td>未答题：{{ unanswered }}人</td>
            </tr>
            <tr v-show="read + unread > 0">
              <td>佔比：{{ ((read / (read + unread)) * 100).toFixed(2) }}%</td>
              <td>
                佔比：{{ ((unread / (read + unread)) * 100).toFixed(2) }}%
              </td>
              <td>
                佔比：{{
                  ((unanswered / (read + unread + unanswered)) * 100).toFixed(
                    2
                  )
                }}%
              </td>
            </tr>
            <tr v-show="read + unread == 0 && unanswered > 0">
              <td>佔比： 0.00%</td>
              <td>佔比： 0.00%</td>
              <td>
                佔比：{{
                  ((unanswered / (read + unread + unanswered)) * 100).toFixed(
                    2
                  )
                }}%
              </td>
            </tr>
            <tr v-show="read + unread + unanswered == 0">
              <td>佔比： 0.00%</td>
              <td>佔比： 0.00%</td>
              <td>佔比： 0.00%</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="btn">
      <el-button type="primary" @click="derive">導出</el-button>
      <el-button @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
export default {
  data() {
    return {
      title: "",
      myChart: undefined,
      myChart2: undefined,
      id: "",
      typeName: ["", "分公司", "部門/物業", "用戶組別", "職位"],
      type: 1,
      read: 0,
      unread: 0,
      unanswered: 0,
      allMsg: [],
      legendData: [],
      seriesData: [],
      req: {},
      url: "",
      deriveUrl: "",
      courseId: "",

      graphTitle: '',
      subTitle: '',
      catagoryList: [],
      unreadList: [],
      untestList: [],
      passList: [],
      noPassList: [],
      empty: []
    };
  },
  methods: {
    statistics() {
      var option = {
        tooltip: {
          trigger: "item",
          formatter: (data) => {
            let msg = this.allMsg[this.allMsg.length - data.dataIndex - 1];
            let total = msg.yesNum + msg.noNum + msg.isNum
            return (
              `${data.name}<br/>` +
              `總共人數：${total}人<br/>` + 
              `未讀人數：${msg.unreadNum}人（${(100 * msg.unreadNum / total).toFixed(2)}%）<br/>` +
              `未答题人數：${msg.isNum - msg.unreadNum}人（${(100 * (msg.isNum - msg.unreadNum) / total).toFixed(2)}%）<br/>` +
              `合格人數：${msg.yesNum}人（${msg.yesPercent}）<br/>` +
              `不合格人數：${msg.noNum}人（${msg.noPercent}）<br/>`
            );
          },
        },
        color: ['#5871C0', '#238C96', '#2BBF3E', '#f74138', '#FFFFFF00'],
        legend: {
          orient: "horizontal",
        },
        grid: {
          left: '2%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          axisLabel: {
            width: 240
          },
          label: {
            color: '#2F2F2F'
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          name: '未讀人數',
          type: 'bar',
          stack: 'read',
          label: {
            show: true,
            formatter: (params) => {
              let index = params.dataIndex
              let xMaxRange = this.myChart.getModel().getComponent('xAxis').axis.scale._extent[1]
              if (this.unreadList[index] / xMaxRange > 0.05) {
                return `${this.unreadList[index]}`
              } else {
                return ''
              }
            }
          },
          data: []
        },
        {
          name: '已讀未測驗人數',
          type: 'bar',
          stack: 'read',
          label: {
            show: true,
            formatter: (params) => {
              let index = params.dataIndex
              let xMaxRange = this.myChart.getModel().getComponent('xAxis').axis.scale._extent[1]
              if (this.untestList[index] / xMaxRange > 0.05) {
                return `${this.untestList[index]}`
              } else {
                return ''
              }
            }
          },
          data: [],
        },
        {
          name: '合格人數',
          type: 'bar',
          stack: 'read',
          label: {
            show: true,
            formatter: (params) => {
              let index = params.dataIndex
              let xMaxRange = this.myChart.getModel().getComponent('xAxis').axis.scale._extent[1]
              if (this.passList[index] / xMaxRange > 0.05) {
                return `${this.passList[index]}`
              } else {
                return ''
              }
            }
          },
          data: [],
        },
        {
          name: '不合格人數',
          type: 'bar',
          stack: 'read',
          label: {
            show: true,
            formatter: (params) => {
              let index = params.dataIndex
              let xMaxRange = this.myChart.getModel().getComponent('xAxis').axis.scale._extent[1]
              if (this.noPassList[index] / xMaxRange > 0.05) {
                return `${this.noPassList[index]}`
              } else {
                return ''
              }
            }
          },
          data: [],
        },
        {
          name: '',
          type: 'bar',
          stack: 'read',
          data: [],
        }],
      };
      this.myChart.setOption(option);
    },
    getNewMsg: function (showAll = false) {
      this.graphTitle = this.typeName[this.type]

      let key = "",
        idType = "",
        type = this.type;
      switch (type) {
        case 1:
          key = "regionName";
          idType = "";
          break;
        case 2:
          key = "branchName";
          idType = "regionId";
          break;
        case 3:
          key = "departmentName";
          idType = "branchId";
          break;
        default:
          key = "positionName";
          idType = "departmentId";
          break;
      }
      let request = { courseId:this.courseId,sectionId: this.id, type: type };
      if (idType && !showAll) {
        console.log(idType);
        request[idType] = this.req[idType];
        console.log(request);
      }
      this.axios({
        url: this.url,
        params: request,
      }).then((res) => {
        if (res) {
          let msg = res.result;
          console.log(msg)
          this.allMsg = msg;
          this.read = 0;
          this.unread = 0;
          this.unanswered = 0;
          var maxCount = 0
          var catagoryList = [], unreadList = [], untestList = [], passList = [], noPassList = [], empty = []
          res.result.forEach(item => {
            catagoryList.push(item[key])
            unreadList.unshift(item.unreadNum)
            untestList.unshift(item.isNum - item.unreadNum)
            passList.unshift(item.yesNum)
            noPassList.unshift(item.noNum)
            maxCount = Math.max(maxCount, item.isNum + item.yesNum + item.noNum)
            this.read += item.yesNum
            this.unread += item.noNum
            this.unanswered += item.isNum
          })
          res.result.forEach(item => {
            empty.unshift(maxCount - item.isNum - item.yesNum - item.noNum)
          })
          this.myChart.setOption({
            yAxis: {
              type: 'category',
              data: catagoryList.reverse()
            },
            series: [
              { data: unreadList },
              { data: untestList },
              { data: passList },
              { data: noPassList },
              { data: empty }
            ]
          })
          // 重设高度
          this.myChart.resize({
            height: Math.max(res.result.length * 20, 500)
          })
        }
      });
    },
    restoreImg(num) {
      let canvas = $("canvas")[num];
      console.log(canvas);
      let date = new Date();
      let name =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        this.typeName[this.type] +
        "學習記錄"; // 'canvas绘制图片'为图片默认名
      let href = canvas.toDataURL("image/png", 1); // 获取canvas对应的base64编码
      let a = document.createElement("a"); // 创建a标签
      a.download = name; // 设置图片名字
      a.href = href;
      a.dispatchEvent(new MouseEvent("click"));
      a.remove();
    },
    derive() {
      let link = document.createElement("a");
      var token = localStorage.getItem("token");
      link.setAttribute(
        "href",
        this.URL + this.deriveUrl + token + "&id=" + this.id
      );
      link.click();
      link.remove();
    },
    categoryChange() {
      this.subTitle = ''
      this.getNewMsg(true)
    }
  },
  mounted() {
    $("#pageHead").text("學習記錄詳情");
    this.myChart = echarts.init(document.getElementById("analyze"));
    this.getNewMsg();
    this.myChart.on("click", (e) => {
      this.req = this.allMsg[this.allMsg.length - e.dataIndex - 1];
      this.subTitle = `base on ${e.name}`
      if (this.type < 4) {
        this.type++;
      } else {
        this.type = 1;
      }
      this.getNewMsg();
    });
    this.statistics();
  },
  created() {
    this.courseId = sessionStorage.getItem("courseId");
    let msg = JSON.parse(sessionStorage.getItem("sectionMsg"));
    this.id = msg.id;
    this.title = msg.sectionName + "學習記錄";

    let courseType = sessionStorage.getItem("courseType");
    if (courseType == "online") {
      this.url = "/manage/getOnlineSectionStatistics";
      this.axios({
        url: '/manage/getOnTestingAndUeviomsName',
        params: {
          id: this.id
        }
      }).then(res => {
        if (res) {
          let result = res.result;
          if (result && result.testingId) {
              this.deriveUrl = "/manage/getOnlineSectionsExcel?type=1&login_token=";
            }else{
              this.deriveUrl = "/manage/getOnlineSectionsExcel?type=2&login_token=";
            }
        }
      });

    } else if (courseType == "offline") {
      this.url = "/manage/getOfflineSectionStatistics";
      this.deriveUrl = "/manage/getOfflineSectionsExcel?login_token=";
    } else {
      this.url = "/manage/getLiveSectionStatistics";
      this.deriveUrl = "/manage/getLiveSectionsExcel?login_token=";
    }
  },
};
</script>

<style scoped>
#body {
  width: 100%;
}
#echart2 div {
  width: 90%;
}
.statistics {
  /* justify-content: space-around; */
  align-items: center;
  flex-direction: column;
}
.statistics {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
#head {
  border: #c6c6c6 1px solid;
  background-color: #f2f2f2;
  padding: 9px 15px;
  margin-bottom: 20px;
}
.graph-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}
.graph-sub-title {
  text-align: center;
}
.heading {
  padding-bottom: 12px;
}
.filter {
  width: 85%;
  margin: 0 auto;
}
</style>
